import type { ReactNode } from 'react';

/** The rail is always slim — labels live in tooltips, content owns the width. */
export const SIDEBAR_WIDTH = 72;
/** Mobile drawer (full labels) keeps a comfortable reading width. */
export const MOBILE_DRAWER_WIDTH = 260;

/** Light ink on the dark instrument rail (contrast > 7:1 on #121a19). */
export const RAIL_TEXT = '#e8efee';
export const RAIL_TEXT_DIM = 'rgba(232, 239, 238, 0.65)';
export const RAIL_HOVER = 'rgba(255, 255, 255, 0.06)';

export interface AppSidebarItem {
  labelKey: string;
  path: string;
  icon: ReactNode;
}
